// src/components/global/Table/EmptyStateRow.jsx
import React from 'react';
import { Box, TableRow, TableCell, Typography, useTheme } from '@mui/material';
import FolderOffOutlinedIcon from '@mui/icons-material/FolderOffOutlined';

const EmptyStateRow = ({ colSpan, isArabic, labelAr, labelEn }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    return (
        <TableRow>
            <TableCell colSpan={colSpan} align="center" sx={{ py: 8 }}>
                <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                    <Box
                        sx={{
                            width: 80,
                            height: 80,
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)',
                            color: theme.palette.text.disabled,
                        }}
                    >
                        <FolderOffOutlinedIcon sx={{ fontSize: 40 }} />
                    </Box>
                    <Typography variant="h6" color="text.secondary" fontWeight="600">
                        {isArabic ? labelAr : labelEn}
                    </Typography>
                    <Typography variant="body2" color="text.disabled" sx={{ maxWidth: 300, textAlign: 'center' }}>
                        {isArabic
                            ? 'لا توجد بيانات متاحة للعرض حاليًا في هذا الجدول.'
                            : 'There is currently no data to display in this table.'}
                    </Typography>
                </Box>
            </TableCell>
        </TableRow>
    );
};

export default EmptyStateRow;
